import React from "react";

import { FormCheckbox } from "../../../forms/FormCheckbox";
import { IFormUUID } from "../../../models/nominals";
import { IWriteReviewTemplateField } from "../../../models/reviews.interfaces";
import { useAppSelector, useDispatchers } from "../../reducers";
import { Dispatchers } from "../dispatchers";
import { getWriteReviewFormState } from "../selectors";

interface IOwnProps {
    formUUID: IFormUUID;
    name: string;
    field: IWriteReviewTemplateField;
}

export const WriteReviewFormCheckboxField = (
    props: IOwnProps,
): React.ReactNode => {
    const dispatchers = useDispatchers(Dispatchers);

    const { values, errors, showErrors } = useAppSelector((rootState) => {
        const formState = getWriteReviewFormState(rootState.reviews, props);
        return {
            values: formState.valuesMultiSelect[props.name] ?? [],
            errors: formState.errors[props.name] ?? [],
            showErrors: formState.showErrors,
        };
    });

    const onChange = (e: React.FormEvent<HTMLInputElement>) => {
        dispatchers.onReviewFormCheckboxChange({
            formUUID: props.formUUID,
            fieldName: props.name,
            fieldValue: e.currentTarget.value,
            isChecked: e.currentTarget.checked,
        });
    };

    const inputs = props.field.options.map((option) => {
        return (
            <FormCheckbox
                key={option}
                name={`${props.name}-${props.formUUID}`}
                required={props.field.is_required}
                label={option}
                labelPlacement={"static"}
                value={option}
                errors={errors}
                showErrorMessages={showErrors}
                checked={values.includes(option)}
                onChange={onChange}
            />
        );
    });

    return (
        <fieldset>
            <legend>{props.field.name}</legend>
            {inputs}
        </fieldset>
    );
};
